import { render, staticRenderFns } from "./vsRadioCustom.vue?vue&type=template&id=015bf5ff"
import script from "./vsRadioCustom.vue?vue&type=script&lang=js"
export * from "./vsRadioCustom.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\xampp\\htdocs\\site-teste\\flash-master\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('015bf5ff')) {
      api.createRecord('015bf5ff', component.options)
    } else {
      api.reload('015bf5ff', component.options)
    }
    module.hot.accept("./vsRadioCustom.vue?vue&type=template&id=015bf5ff", function () {
      api.rerender('015bf5ff', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "Resources/js/src/components/vsRadioCustom/vsRadioCustom.vue"
export default component.exports